import React from 'react';
import { Spacer, Text } from '@ontruck/orc';
import { StyledList } from './styled/StyledList';

const t = {
  task: 'Task',
  incidents_reported: 'Incidents reported',
  no_incidents_reported: 'No incidents reported',
  total_confirmed_pallets: 'Total confirmed pallets',
  of: 'of',
  total_scanned_labels: 'Total scanned labels',
  xdock_observations: `XDock's observations`,
  driver_observations: `Driver's observations`,
  driver_incident_image: `Driver's incident image`,
  owner: 'Owner',
  no_owner: 'No owner yet',
};

const xDockIncidentRenderer = ({
  changes: { task, owner, task_info },
  shipperOrderId: originalShipperOrderId,
  action,
  ...props
}) => {
  const {
    observations,
    incident_type,
    total_pallets,
    confirmed_pallets,
    scanned_pallet,
    incident_image,
  } = task_info;

  const observationsLabel =
    action === 'TASK_CREATED_DRIVER' ? t.driver_observations : t.xdock_observations;

  return (
    <Spacer {...props}>
      {task && (
        <Spacer mBottom="XS">
          <Text color="grey900" display="block">
            {`${t.task}: ${task}`}
          </Text>
        </Spacer>
      )}
      <Text color="grey700" display="block">
        {incident_type && incident_type?.length > 0
          ? `${t.incidents_reported}:`
          : t.no_incidents_reported}
      </Text>
      {incident_type && incident_type?.length > 0 && (
        <StyledList>
          {incident_type.map((incident) => (
            <li key={`incident-${incident}`}>{incident}</li>
          ))}
        </StyledList>
      )}
      {confirmed_pallets !== undefined && total_pallets !== undefined && (
        <Spacer mBottom="XXS">
          <Text color="grey700" display="inline-block">
            <Spacer mRight="XXS">{`${t.total_confirmed_pallets}: `}</Spacer>
          </Text>

          <Text color="grey900" display="inline-block" weight="bold">
            <Spacer mRight="XXS">{` ${confirmed_pallets} `}</Spacer>
          </Text>

          <Text color="grey900" display="inline-block">
            {`${t.of} ${total_pallets}`}
          </Text>
        </Spacer>
      )}
      {scanned_pallet !== undefined && total_pallets !== undefined && (
        <Spacer mBottom="XS">
          <Text color="grey700" display="inline-block">
            <Spacer mRight="XXS">{`${t.total_scanned_labels}: `} </Spacer>
          </Text>
          <Text color="grey900" display="inline-block" weight="bold">
            <Spacer mRight="XXS">{` ${scanned_pallet} `}</Spacer>
          </Text>
          <Text color="grey900" display="inline-block">
            {`${t.of} ${total_pallets}`}
          </Text>
        </Spacer>
      )}
      {observations && (
        <Spacer mBottom="XS">
          <Text color="grey700" display="inline-block">
            <Spacer mRight="XXS">{`${observationsLabel}: `}</Spacer>
          </Text>
          <Text color="grey900" display="inline-block">
            {` ${observations}`}
          </Text>
        </Spacer>
      )}
      {incident_image && (
        <Spacer mBottom="XS">
          <Text color="grey700" display="inline-block">
            <Spacer mRight="XXS">{`${t.driver_incident_image}: `}</Spacer>
          </Text>
          <Text color="grey900" display="inline-block">
            <a href={incident_image} target="_blank" rel="noreferrer" data-testid="link">
              View incident image
            </a>
          </Text>
        </Spacer>
      )}
      <Text color="grey900" display="block">
        {`${t.owner}: ${owner || t.no_owner}`}
      </Text>
    </Spacer>
  );
};

export default xDockIncidentRenderer;
